package uk.co.nickthecoder.kyd

import uk.co.nickthecoder.glok.property.boilerplate.booleanProperty

/**
 * See [Game.stageDescriptions]
 */
class StageDescription {

    var stageName: String = "main"

    var stageType: String = "uk.co.nickthecoder.kyd.Stage"

    /**
     * Should the StageView's pan/zoom and rotation properties be bound to the ActView?
     *
     * Change this to `false` for stages which do not move with the rest of the game.
     * e.g. for a `glass` stage, containing UI elements, game-score etc.
     *
     * If your game doesn't scroll, zoom or rotate, this has no effect.
     */
    var linked: Boolean = true

    /**
     * Only used by the editor, so (temporarily) hide stages views.
     */
    val visibleProperty by booleanProperty(true)
    var visible by visibleProperty

    override fun toString() = stageName
}
